import React from 'react';
import styled from 'styled-components';

const breakpoints = { tablet: 768, phone: 480 };

const GreetingContainer = styled.div`
  text-align: left;
  margin-top: 20px;
  margin-left: 50px;

  @media (max-width: ${breakpoints.tablet}px) {
    margin-top: 16px;
    margin-left: 30px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    margin-top: 12px;
    margin-left: 60px;
  }
`;

const GreetingText = styled.div`
  font-size: 36px;
  color: ${({ colors }) => colors.titleText || '#333'};
  font-weight: 500;

  @media (max-width: ${breakpoints.tablet}px) {
    font-size: 28px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    font-size: 22px;
  }
`;

const PromptText = styled.div`
  font-size: 16px;
  margin-top: 5px;
  color: ${({ colors }) => colors.secondaryText || '#666'};

  @media (max-width: ${breakpoints.tablet}px) {
    font-size: 14px;
    margin-top: 4px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    font-size: 12px;
    margin-top: 3px;
  }
`;

const getTimeOfDayGreeting = () => {
  const currentHour = new Date().getHours();
  if (currentHour < 12) return 'Good Morning';
  if (currentHour < 18) return 'Good Afternoon';
  return 'Good Evening';
};

export default function Greeting({ username, colors }) {
  return (
    <GreetingContainer>
      <GreetingText colors={colors}>
        {getTimeOfDayGreeting()}, {username}!
      </GreetingText>
      <PromptText colors={colors}>What would you like to do?</PromptText>
    </GreetingContainer>
  );
}
